<template>
        <section class="landscape-recent-blogs-wrap clearfix">
          <h2 v-if="blogs.length" class="text-center text-uppercase mt-5 mb-4">Recent Blogs</h2>
          <div class="container">
            <div class="px-100">
              <p v-if="!loading && blogs.length === 0" class="mt-4 text-center">No Data Found</p>
              <div class="recent-blogs-content landscape-recent-blogs">
                <RecentBlogCard class="margin-10" v-for="blog in blogs" :key="blog.id" :blog="blog"/>
              </div>
            </div>
          </div>
          <div v-if="blogs?.length" class="d-flex justify-content-center m-3">
            <button type="button" @click="seeMore" class="btn btn-outline-primary">
              <span>See More</span>
            </button>
          </div>
        </section>
</template>

<script>
    import RecentBlogCard from './RecentBlogCard.vue';
    import { slickPrevArrow, slickNextArrow } from '../../functions';

    export default {
        components: { RecentBlogCard },
        data() {
            return {
                loading: true,
                blogs: [],
            };
        },
        mounted() {
            this.getRecentBlogs();
        },
        methods: {
            selector() {
                return $('.landscape-recent-blogs');
            },

          slickOptions() {
            return {
              rows: 0,
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 4,
              rtl: window.Trillion.rtl,
              responsive: [
                {
                  breakpoint: 1550,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                  }
                },
                {
                  breakpoint: 1281,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 920,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            }
          },

            getRecentBlogs() {
                this.loading = true;

                $.ajax({
                    method: 'GET',
                    url: 'api/recent_blogs',
                }).then((blogs) => {
                    if (this.selector().hasClass('slick-initialized')) {
                        this.selector().slick('unslick');
                    }

                    this.blogs = blogs;

                    this.loading = false;

                    this.$nextTick(() => {
                        this.selector().slick(this.slickOptions());
                    });
                });
            },

            seeMore() {
                window.open('/blogs', '_blank');
            },
        },
    };
</script>

<style>
.margin-10{
    margin: 0 10px;
}
</style>
